<template>
  <div class="ii-layout-normal">
    <a-layout>
      <a-layout-header>
        <component :is="item" v-for="(item, i) in $state.layout.normal.head.left" :key="i"> </component>
        <component :is="item" v-for="(item, i) in $state.layout.normal.head.center" :key="i"> </component>
        <component :is="item" v-for="(item, i) in $state.layout.normal.head.right" :key="i"> </component>
      </a-layout-header>
      <a-layout-content>
        <router-view v-slot="{ Component }">
          <transition name="slide-fade">
            <component :is="Component" />
          </transition>
        </router-view>
      </a-layout-content>
      <a-layout-footer>
        <component :is="item" v-for="(item, i) in $state.layout.normal.footer.center" :key="i"> </component>
      </a-layout-footer>
    </a-layout>
  </div>
</template>

<script setup lang="ts">
import { useNormalPageLayout } from "../DefaultPortalPagePlugin";
const { $state } = useNormalPageLayout();
</script>
<style scoped lang="less">
@import "@/styles/vars.less";
.ii-layout-normal {
  :deep(.ant-layout-header) {
    background: @primary-color;
  }
}
</style>
